var map = {
	"./POI1.jpg": 5661,
	"./POI10.jpg": 1121,
	"./POI11.jpg": 3076,
	"./POI12.jpg": 8355,
	"./POI13.jpg": 5190,
	"./POI14.jpg": 3005,
	"./POI15.jpg": 7424,
	"./POI16.jpg": 1039,
	"./POI17.jpg": 3106,
	"./POI18.jpg": 1817,
	"./POI19.jpg": 92,
	"./POI2.jpg": 9730,
	"./POI20.jpg": 9616,
	"./POI21.jpg": 541,
	"./POI3.jpg": 1439,
	"./POI4.jpg": 4,
	"./POI5.jpg": 4337,
	"./POI6.jpg": 6582,
	"./POI7.jpg": 9715,
	"./POI8.jpg": 5256,
	"./POI9.jpg": 3125,
	"./app-background-wide.jpg": 9376,
	"./app-background.jpg": 4270,
	"./character-Pierre.png": 8497,
	"./character-fricfrac.png": 5178,
	"./character-lea.png": 6690,
	"./character-mesange-huppe.png": 6197,
	"./empty": 2463,
	"./home-background.jpg": 4936,
	"./poi_10_en.mp3": 5510,
	"./poi_10_fr.mp3": 3647,
	"./poi_11_en.mp3": 8961,
	"./poi_11_fr.mp3": 2412,
	"./poi_12_en.mp3": 996,
	"./poi_12_fr.mp3": 4465,
	"./poi_13_en.mp3": 3919,
	"./poi_13_fr.mp3": 9606,
	"./poi_14_en.mp3": 1458,
	"./poi_14_fr.mp3": 6579,
	"./poi_15_en.mp3": 5965,
	"./poi_15_fr.mp3": 5856,
	"./poi_16_en.mp3": 7200,
	"./poi_16_fr.mp3": 8357,
	"./poi_17_en.mp3": 4635,
	"./poi_17_fr.mp3": 650,
	"./poi_18_en.mp3": 5262,
	"./poi_18_fr.mp3": 935,
	"./poi_19_en.mp3": 2729,
	"./poi_19_fr.mp3": 4116,
	"./poi_1_en.mp3": 5998,
	"./poi_1_fr.mp3": 6775,
	"./poi_20_en.mp3": 9993,
	"./poi_20_fr.mp3": 7508,
	"./poi_21_en.mp3": 6942,
	"./poi_21_fr.mp3": 3895,
	"./poi_2_en.mp3": 3111,
	"./poi_2_fr.mp3": 4798,
	"./poi_3_en.mp3": 7292,
	"./poi_3_fr.mp3": 3529,
	"./poi_4_en.mp3": 8421,
	"./poi_4_fr.mp3": 5720,
	"./poi_5_en.mp3": 5066,
	"./poi_5_fr.mp3": 9803,
	"./poi_6_en.mp3": 3,
	"./poi_6_fr.mp3": 9986,
	"./poi_7_en.mp3": 9208,
	"./poi_7_fr.mp3": 8157,
	"./poi_8_en.mp3": 5809,
	"./poi_8_fr.mp3": 732,
	"./poi_9_en.mp3": 9510,
	"./poi_9_fr.mp3": 9247,
	"./tour1.jpg": 8885,
	"./tour1photo.jpg": 4205,
	"./tour1photo.old.jpg": 7260,
	"./tour2.jpg": 1034,
	"./tour2photo.jpg": 6004,
	"./tour2photo.old.jpg": 7249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8458;